import CryptoJS from "crypto-js";

interface ApiOptions {
  responseType?: "json" | "arraybuffer";
  usePixelsApi?: boolean;
}

// Pixels API URL from environment variable or default to staging
const PIXELS_SERVER_URL = process.env.REACT_APP_PIXELS_SERVER_URL;


export const getJwt = (): string | null => {
  const encryptedJwt = localStorage.getItem("jwt");
  let jwt: string | null = null;

  // Decrypt JWT if present
  if (encryptedJwt) {
    const bytes = CryptoJS.AES.decrypt(
      encryptedJwt,
      process.env.REACT_APP_CRYPTO_SECRET_KEY ?? ""
    );
    jwt = bytes.toString(CryptoJS.enc.Utf8);
  }
  return jwt
}

export const api = async (
  url_extension: string,
  method: string,
  data?: any,
  options?: ApiOptions
): Promise<any> => {
  let jwt = getJwt();
  // We'll build headers conditionally
  const headers = new Headers();
  if (jwt) {
    headers.set("Authorization", `Bearer ${jwt}`);
  }

  let body: BodyInit | undefined;

  // If data is a FormData object, let the browser set multipart/form-data automatically.
  if (data instanceof FormData) {
    body = data;
  } else if (data) {
    // Otherwise, assume JSON
    headers.set("Content-Type", "application/json");
    body = JSON.stringify(data);
  }
  // If no data, body remains undefined.

  // Determine which base URL to use
  const baseUrl = options?.usePixelsApi
    ? PIXELS_SERVER_URL
    : process.env.REACT_APP_BASE_BACKEND_URL ?? "";

  const response = await fetch(baseUrl + url_extension, {
    method,
    headers,
    body,
  });

  if (!response.ok) {
    // Create a serializable error object that Redux Toolkit can handle
    const errorData = {
      message: response.statusText || "Network response was not ok",
      status: response.status,
      statusText: response.statusText,
    };
    
    // Try to get error details from response body if available
    try {
      const errorBody = await response.json();
      if (errorBody.detail) {
        errorData.message = errorBody.detail;
      }
    } catch {
      // If response body isn't JSON, use status text
    }
    
    throw errorData;
  }

  if (options?.responseType === "arraybuffer") {
    return response.arrayBuffer();
  }

  return response.json();
};
